import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomJwtPayload, setToken } from "../helpers/helperFunctions";

export interface AppState {
  userDetails: null | ICustomJwtPayload;
  isLogged: boolean;
  showLoader: boolean;
  messageUnreadCount: number;
  unreadNotificationCount: number;
  pleaseLoginModal: boolean;
  websiteLanguage: {
    code: string;
    label: string;
    country: string;
    countryCode: string;
  };
  homeCareAppointementDrawer: string | null;
}

const initialState: AppState = {
  userDetails: null,
  isLogged: false, // change after api integrate
  showLoader: false,
  messageUnreadCount: 0,
  unreadNotificationCount: 0,
  pleaseLoginModal: false,
  homeCareAppointementDrawer: null,
  websiteLanguage: {
    code: "en",
    label: "English",
    country: "United Arab Emirates",
    countryCode: "UAE",
  },
};

export const reducer = createSlice({
  name: "APP_REDUCER",
  initialState,
  reducers: {
    setCounter: (
      state,
      action: PayloadAction<{
        key: "messageUnreadCount" | "unreadNotificationCount";
        val: number;
      }>
    ) => {
      state[action.payload.key] = action.payload.val;
    },
    counterIncreament: (
      state,
      action: PayloadAction<"messageUnreadCount" | "unreadNotificationCount">
    ) => {
      state[action.payload] = state[action.payload] + 1;
    },
    resetCounter: (
      state,
      action: PayloadAction<"messageUnreadCount" | "unreadNotificationCount">
    ) => {
      state[action.payload] = 0;
    },
    setAuth: (state, action: PayloadAction<string>) => {
      setToken(action.payload);
      state.isLogged = true;
      // setTimeout(() => {
      // }, 100);
    },
    setUserDetails: (state, action: PayloadAction<ICustomJwtPayload>) => {
      state.userDetails = action.payload;
      if (action.payload) {
        state.isLogged = true;
      } else {
        state.isLogged = true;
      }
    },
    removeAuth: (state) => {
      state.userDetails = null;
      state.isLogged = false;
    },
    toggleLoader: (state, action: PayloadAction<boolean>) => {
      state.showLoader = action.payload;
    },
    tooglePleaseLogin: (state, action: PayloadAction<boolean>) => {
      state.pleaseLoginModal = action.payload;
    },
    setUniqueData: (
      state,
      action: PayloadAction<{ key: string; value: string | number }>
    ) => {
      const { key, value } = action.payload;
      // Ensure userDetails is not null before attempting to update it
      if (state.userDetails) {
        state.userDetails = {
          ...state.userDetails,
          [key]: value,
        };
      }
    },
    changeWebsiteLanguage: (
      state,
      action: PayloadAction<{
        code?: string;
        label?: string;
        country?: string;
        countryCode?: string;
      }>
    ) => {
      state.websiteLanguage = { ...state.websiteLanguage, ...action.payload };
    },
    toogleHomeCareAppointementDrawer: (state, action: PayloadAction<string | null>) => {
      state.homeCareAppointementDrawer = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCounter,
  counterIncreament,
  resetCounter,
  setAuth,
  setUserDetails,
  removeAuth,
  toggleLoader,
  tooglePleaseLogin,
  setUniqueData,
  changeWebsiteLanguage,
  toogleHomeCareAppointementDrawer,
} = reducer.actions;

export default reducer.reducer;
